module.exports = __webpack_public_path__ + "static/media/nigerialog.c6d5d5a8.png";